import $ from 'jquery'

export class Calculator {

  constructor($container) {
    this.$container = $container

    this.$step1 = $container.find('[data-step="1"]')
    this.$step2 = $container.find('[data-step="2"]')
    this.$inputHoursAnual = this.$step1.find('input[name="hours_annual"]')
    this.$inputHoursWeekly = this.$step1.find('input[name="weekly_working"]')
    this.$buttonNext = this.$step1.find('button')
    this.$buttonPrev = this.$step2.find('button')

    this.$inputHoursAnual.on('change', this.handleChangeInput.bind(this))
    this.$inputHoursWeekly.on('change', this.handleChangeInput.bind(this))

    this.$buttonNext.on('click', this.handleClickNextButton.bind(this))
    this.$buttonPrev.on('click', this.handleClickPrevButton.bind(this))
  }

  handleChangeInput (e) {
    this.verifyInput($(e.target))
  }

  verifyInput($input) {
    let error = false

    if (!$input.val()) {
      error = true
      $input.addClass('invalid')
      $input.parent().find('.step-error').addClass('active')
    }

    return !error
  }

  resetInput($input) {
    $input.removeClass('invalid')
    $input.parent().find('.step-error').removeClass('active')
  }

  handleClickNextButton() {
    let error = false

    this.resetInput(this.$inputHoursAnual)
    this.resetInput(this.$inputHoursWeekly)

    if (!this.verifyInput(this.$inputHoursAnual)) {
      error = true
    }

    if (!this.verifyInput(this.$inputHoursWeekly)) {
      error = true
    }

    if (!error) {
      let hoursAnnual = this.$inputHoursAnual.val()
      let result = 37.5 * hoursAnnual / this.$inputHoursWeekly.val()

      result = hoursAnnual - result
      result = Math.round(result)

      this.$step2.find('.hour').text(result)

      this.$step1.removeClass('active')
      this.$step2.addClass('active')
    }
  }

  handleClickPrevButton() {
    this.$step2.removeClass('active')
    this.$step1.addClass('active')
  }
}
